<template>
  <div>
    <div class="logo-container" @click="onLogoClick">
      <span class="name" v-if="!collapse">
        {{ serverVersion.applname }}
      </span>
    </div>
    <div style="overflow: hidden;">
      <el-menu
        background-color="#90b4ce"
        text-colorp="red"
        active-text-color="#d7e7d4"
        class="el-menu-vertical"
        :collapse-transition="false"
        :collapse="collapse"
        :router="true"
        :default-active="activeLink"
      >
        <template v-for="menu in verticalMenu">
          <el-submenu
            v-if="
              isAccess(menu.code) && menu.children && menu.children.length > 0
            "
            :index="menu.link"
            :key="menu.link"
          >
            <template slot="title">
              <i :class="menu.icon"></i>
              <span slot="title">{{ menu.name }}</span>
            </template>
            <el-menu-item-group>
              <template v-for="child in menu.children">
                <el-menu-item
                  v-if="isAccess(child.code)"
                  :index="child.link"
                  :key="child.link"
                >
                  <i :class="child.icon"></i>
                  <span slot="title">{{ child.name }}</span>
                </el-menu-item>
              </template>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item
            v-if="isAccess(menu.code) && !menu.children"
            :index="menu.link"
            :key="`${menu.link}`"
          >
            <i :class="menu.icon"></i>
            <span slot="title">{{ menu.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { parseVersionFloat, parseApiVersion } from "@/helpers/compare";
import { getHost } from "@/helpers/url";

export default {
  name: "menuvertical",
  props: ["collapse"],
  data() {
    return {
      activeLink: null,
      verticalMenu: [
        {
          name: this.$t("common.menu.massinput.name"),
          description: "",
          icon: "el-icon-folder-opened",
          link: "massinput",
          code: [40],
          children: [
            {
              name: this.$t("common.menu.massinput.enteringPayments.name"),
              description: this.$t(
                "common.menu.massinput.enteringPayments.desc"
              ),
              icon: "el-icon-data-line",
              link: "/enteringpayments",
              code: [40]
            },
            {
              name: this.$t("common.menu.massinput.enteringSubsidies.name"),
              description: this.$t(
                "common.menu.massinput.enteringSubsidies.desc"
              ),
              icon: "el-icon-data-analysis",
              link: "/enteringsubsidies",
              code: [40]
            }
          ]
        },
        {
          name: this.$t("common.menu.subscribers.name"),
          description: this.$t("common.menu.subscribers.desc"),
          icon: "el-icon-user",
          link: "/subscribers",
          code: [84]
        },
        {
          name: this.$t("common.menu.searchchange.name"),
          description: "",
          icon: "el-icon-search",
          link: "searchchange",
          code: [44, 45],
          children: [
            {
              name: this.$t("common.menu.searchchange.errorpayments.name"),
              description: this.$t(
                "common.menu.searchchange.errorpayments.desc"
              ),
              icon: "el-icon-copy-document",
              link: "/errorpayments",
              code: [44, 45]
            }
          ]
        },
        {
          name: this.$t("common.menu.paymentdocuments.name"),
          description: "",
          icon: "el-icon-document",
          link: "paymentdocuments",
          code: [75, 76, 77],
          children: [
            {
              name: this.$t("common.menu.paymentdocuments.bankPay.name"),
              description: this.$t("common.menu.paymentdocuments.bankPay.desc"),
              icon: "el-icon-bank-card",
              link: "/bankpay",
              code: [75]
            },
            {
              name: this.$t("common.menu.paymentdocuments.packsReceipts.name"),
              description: this.$t(
                "common.menu.paymentdocuments.packsReceipts.desc"
              ),
              icon: "el-icon-files",
              link: "/packsreceipts",
              code: [76]
            },
            {
              name: this.$t("common.menu.paymentdocuments.relationship.name"),
              description: this.$t(
                "common.menu.paymentdocuments.relationship.desc"
              ),
              icon: "el-icon-connection",
              link: "/relationship",
              code: [76]
            },
            {
              name: this.$t(
                "common.menu.paymentdocuments.assignOperators.name"
              ),
              description: this.$t(
                "common.menu.paymentdocuments.assignOperators.desc"
              ),
              icon: "el-icon-place",
              link: "/assignoperators",
              code: [76]
            },
            {
              name: this.$t("common.menu.paymentdocuments.controlPacks.name"),
              description: this.$t(
                "common.menu.paymentdocuments.controlPacks.desc"
              ),
              icon: "el-icon-folder-checked",
              link: "/controlpacks",
              code: [77]
            },
            {
              name: this.$t(
                "common.menu.paymentdocuments.controlInetPays.name"
              ),
              description: this.$t(
                "common.menu.paymentdocuments.controlInetPays.desc"
              ),
              icon: "el-icon-shopping-cart-2",
              link: "/controlinetpays",
              code: [77]
            }
          ]
        },
        // {
        //   name: this.$t("common.menu.acceptedshipment.name"),
        //   description: this.$t("common.menu.acceptedshipment.desc"),
        //   icon: "el-icon-reading",
        //   link: "/acceptedshipment",
        //   code: [66]
        // },
        {
          name: this.$t("common.menu.reports.name"),
          description: this.$t("common.menu.reports.desc"),
          icon: "el-icon-document-copy",
          link: "/reports",
          code: [66]
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "config",
      "base",
      "apiVersion",
      "serverVersion",
      "isUserSignin",
      "isBasePresent",
      "externalAuth",
      "wbAccess"
    ])
  },
  watch: {
    $route(value) {
      this.activeLink = value.path;
    },
    wbAccess: async function(value) {
      if (value.length > 0) {
        await this.getServerVersion();
      }
    },
    serverVersion: async function(value) {
      if (value.version !== "") {
        await this.getApiVersion();
      }
    },
    apiVersion: function(value) {
      if (value.version !== "") {
        const remoteApiVersion = parseApiVersion(this.apiVersion.version);

        // проверка версии базы данных
        const apiVersion = this.apiVersion.version;
        const dataBaseVersion = this.serverVersion.databasevers;
        const splitApiVersion = apiVersion.split("-");
        const splitDataBaseVersion = dataBaseVersion.split("-");

        if (splitApiVersion[0] !== splitDataBaseVersion[0]) {
          this.setError(
            `${this.$t("common.checkVersion.serverError")} ${this.$t(
              "common.checkVersion.dataBase"
            )} (${dataBaseVersion}) ${this.$t(
              "common.checkVersion.appServer"
            )} (${apiVersion}) (Database version mismatch)~~~~`
          );
          this.signOut();
        }

        // проверка версии сервера на web
        if (
          parseVersionFloat(this.serverVersion.version) <
          parseVersionFloat(MINVERSIONS.server)
        ) {
          this.setError(
            `${this.$t("common.checkVersion.server")} ${
              MINVERSIONS.server
            } ${this.$t(
              "common.checkVersion.callTo"
            )} (Server version mismatch)~~~~`
          );
          this.signOut();
        }

        // проверка версии web на сервере
        if (this.serverVersion.errorMessage) {
          this.setError(this.serverVersion.errorMessage + "~~~~");
          this.signOut();
        }

        this.apiShortVersion = remoteApiVersion.version;
      }
    }
  },
  async created() {
    await this.getWbAccess({ login: this.user.login });
  },
  mounted() {
    this.activeLink = this.$route.path;
  },
  methods: {
    ...mapActions([
      "getWbAccess",
      "getServerVersion",
      "getApiVersion",
      "signOut"
    ]),
    ...mapMutations(["setError"]),
    onLogoClick() {
      this.externalAuth
        ? (window.location.href = `${getHost()}`)
        : this.$router.push("/");
    },
    isAccess(code) {
      return code.some(v => this.wbAccess.includes(v));
    }
  }
};
</script>

<style scoped>
.logo-container {
  position: sticky;
  top: 0px;
  height: 50px;
  line-height: 50px;
  z-index: 2000;
  background-color: #76a7ca;
  background-image: url("../assets/logo.svg");
  background-repeat: no-repeat;
  background-position: top 7px left 14px;
  overflow: hidden;
  cursor: pointer;
}

.name {
  margin-left: 60px;
  font-size: 1.6em;
  font-weight: bold;
  color: #303133;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 300px;
}

.el-submenu__title i {
  color: #303133;
}

.el-menu-item i {
  color: #303133;
}
</style>

<style>
.el-menu-item-group__title {
  padding: 0 !important;
}

.el-submenu__icon-arrow {
  color: #303133 !important;
}
</style>
